import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectIsInstructor } from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { skipUndefined } from 'thkee-common';

@Component({
  selector: 'app-new-course-header',
  templateUrl: './new-course-header.component.html',
  styleUrls: ['./new-course-header.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, AsyncPipe, AngularSvgIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewCourseHeaderComponent implements OnInit {
  isInstructor$ = this.store.select(selectIsInstructor).pipe(skipUndefined());

  constructor(private readonly store: Store<AppState>) {}

  ngOnInit(): void {}
}
